import React from "react";

import eruda from "eruda";
import "@ant-design/v5-patch-for-react-19";

import "./data";
import "../init";

import extend from "./setting/extend";
import Global from "./global/Global";
import MyRoutes from "./routes";

import "./styles/app.scss";

extend();
const model = window.getQuery("model");

if (model === "eruda") {
  eruda.init();
}

const App = () => {
  return (
    <div className="App">
      <Global />
      <MyRoutes />
    </div>
  );
};

export default App;
